import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { bindActionCreators, Dispatch } from "redux";
import styled from "styled-components";
import OutlineButton from "sweet-web/components/universal/Button/OutlineButton";
import { Title } from "sweet-web/components/universal/Text";
import { MAX_WIDTH } from "sweet-web/lib/constants";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";
import { DeleteVenue } from "sweet-web/redux/venue/actions";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: ${MAX_WIDTH}px;
  margin-top: 20px;
  margin-bottom: 30px;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

type Props = RouteComponentProps & ConnectedProps<typeof connector>;

const VenueHeader: React.FC<Props> = props => {
  const { venueId } = props.match.params as { venueId: string };
  const { venueName, venueActivated } = props;

  const previewListing = () =>
    props.history.push(`/listing/${venueId}/preview`);

  const cancelListing = async () => {
    if (window.confirm("Are you sure you want to cancel your listing?")) {
      props.history.push(`/listings`);
      await props.DeleteVenue(venueId);
    }
  };

  return (
    <Wrapper>
      <Title
        style={{
          color: venueName ? colors.nearBlack : colors.gray
        }}
      >
        {venueName ? venueName : "New Venue"}
      </Title>
      <Buttons>
        <OutlineButton
          link={true}
          color="gray"
          title="Preview Listing"
          onClick={previewListing}
        />
        {!venueActivated && (
          <OutlineButton
            link={true}
            color="gray"
            title="Cancel Listing"
            onClick={cancelListing}
            style={{ marginLeft: 10 }}
          />
        )}
      </Buttons>
    </Wrapper>
  );
};
const mapState = (state: RootState, ownProps: RouteComponentProps) => {
  const { venueId } = ownProps.match.params as { venueId: string };

  return {
    venueName: selectors.venueName(venueId)(state),
    venueActivated: selectors.venueActivated(venueId)(state)
  };
};
const mapDispatch = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      DeleteVenue
    },
    dispatch
  );
const connector = connect(mapState, mapDispatch);

export default withRouter(connector(VenueHeader));
